import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import {
  getTalentEducation,
  type GetTalentEducationParams,
} from './talentEducationApi';

export const TALENT_EDUCATION_QUERY_KEY = ['talent', 'education'] as const;

export function useTalentEducation(params: GetTalentEducationParams) {
  return useQuery({
    queryKey: [
      ...TALENT_EDUCATION_QUERY_KEY,
      params.shortlistPublicKey,
      params.talentPublicKey,
    ],
    queryFn: () => getTalentEducation(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
